import { render, staticRenderFns } from "./PremiumMarketUpload.vue?vue&type=template&id=7ac5f84d&scoped=true"
import script from "./PremiumMarketUpload.vue?vue&type=script&lang=js"
export * from "./PremiumMarketUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ac5f84d",
  null
  
)

export default component.exports